import { Component, ComponentChildren } from 'preact'
import ColorPicker from '../theme-configuration/ColorPicker'
import ConfigurationSectionLabel from './ConfigurationSectionLabel'
import { common } from '../common'
import { WidgetContainerConfigProps } from '../widget-container'
import TextField from '../design-system-components/text-field'

interface WidgetContainerConfigFieldsProps extends WidgetContainerConfigProps {
  widgetName: string
  children: ComponentChildren
  onChange: (config: State) => void
}

interface State extends WidgetContainerConfigProps {
  enablePicker: boolean
  backgroundColorDisplay: string
}

// prettier-ignore
export default class WidgetContainerConfigFields extends Component<WidgetContainerConfigFieldsProps, State> {
  private readonly DISPLAY_OPTIONS_NONE = 'none'
  private readonly DISPLAY_OPTIONS_SOLID_COLOR = 'solid_color'
  private readonly DISPLAY_OPTIONS = [
    {
      key: this.DISPLAY_OPTIONS_NONE,
      value: 'None'
    },
    {
      key: this.DISPLAY_OPTIONS_SOLID_COLOR,
      value: 'Solid color'
    }
  ]

  constructor(props: WidgetContainerConfigFieldsProps) {
    super(props)

    this.state = {
      title: props.title,
      subtitle: props.subtitle,
      backgroundColor: props.backgroundColor,
      backgroundColorDisplay: props.backgroundColorDisplay || this.DISPLAY_OPTIONS_NONE,
      enablePicker: false
    }
  }

  render() {
    const { widgetName, children } = this.props
    const { title, subtitle, backgroundColor, enablePicker, backgroundColorDisplay } = this.state
    // TODO change this module validation to ModulesContext, the issue probably lies on widget-editor/orderAnimation PortalProxy class
    const isFeatureFlagOn = common.isModuleActive('subtitleAndBackgroundToWidgets')

    return (
      <div className={`${widgetName} widget-configurator_tabs-wrapper`}>
        <ConfigurationSectionLabel title='CONTENT'>
          <TextField
            isControl
            size='fullWidth'
            name='container-widget-title'
            label='Title'
            ariaLabel='title'
            id='container-widget-title'
            onChange={(value) => {
              this.setState({
                title: value
              }, () => this.props.onChange(this.state))
            }}
            defaultValue={title}
            updateInputValue={title}
          />
          {isFeatureFlagOn && (
            <TextField
              isControl
              size='fullWidth'
              name='container-widget-subtitle'
              label='Subtitle'
              ariaLabel='subtitle'
              id='container-widget-subtitle'
              onChange={(value) => {
                this.setState({
                  subtitle: value
                }, () => this.props.onChange(this.state))
              }}
              defaultValue={subtitle}
              updateInputValue={subtitle}
            />
          )}
          {children}
        </ConfigurationSectionLabel>
        {isFeatureFlagOn && (
          <ConfigurationSectionLabel title='WIDGET BACKGROUND'>
            <div>
              <label>Background</label>
              <select
                name='widget-background-selector'
                className='widget-background-selector'
                onChange={(event) => {
                  this.setState({
                    backgroundColorDisplay: (event.target as HTMLSelectElement).value
                  }, () => this.props.onChange(this.state))
                }}
              >
                {this.DISPLAY_OPTIONS.map((alignment) => <option
                  key={alignment.key}
                  value={alignment.key}
                  selected={backgroundColorDisplay === alignment.key}
                                                         >{alignment.value}</option>)}
              </select>
            </div>
            {backgroundColorDisplay === this.DISPLAY_OPTIONS_SOLID_COLOR && (
              <div>
                <label>Background Color</label>
                <ColorPicker
                  position='top'
                  color={backgroundColor !== '' && backgroundColor !== undefined ? backgroundColor : '#C4C4C4'}
                  disabled={false}
                  isColorSelectorEnabled={enablePicker}
                  updateColor={(backgroundColor) => {
                    this.setState({ backgroundColor },
                      () => this.props.onChange(this.state))
                  }}
                  disableColorSelector={() => this.setState({ enablePicker: false })}
                  setColorSelector={() => this.setState({ enablePicker: true })}
                />
              </div>
            )}
          </ConfigurationSectionLabel>
        )}
      </div>
    )
  }
}
